import { FulfillmentGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getFulfillmentGroupById = {
  name: "getFulfillmentGroupById" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({ fulfillmentGroup: FulfillmentGroupSchema }),
};
